import { NON_PROFIT } from "constants/clusters";
const MINI_SITE_CONFIGS = {
    [NON_PROFIT]: {
        logo: {
            alt: "monday.com for non-profit",
            url: "/w/nonprofits",
            src: "https://dapulse-res.cloudinary.com/image/upload/mondayhomepage/mini-site/ngo/monday_nonprofit_logo_unify.png",
            mobileSrc: "https://dapulse-res.cloudinary.com/image/upload/mondayhomepage/mini-site/ngo/nonprofits_logo_mobile52h.png",
            useDesktopLogoInMobile: "true"
        },
        links: [
            {
                url: "/w/nonprofits",
                text: "minisite.header.overview",
                removeFromUnified: "true"
            },
            {
                url: "/nonprofits/eligibility",
                text: "minisite.header.eligibility"
            },
            {
                url: "/nonprofits/features",
                text: "minisite.header.features"
            },
            {
                url: "/nonprofits/successhub",
                text: "Resource Center"
            },
            {
                url: "/nonprofits/pricing",
                text: "minisite.header.pricing",
                isPricingPage: "true"
            },
            {
                url: "/nonprofits/success-stories/",
                text: "minisite.header.successStories"
            }
        ],
        unifiedDesktopLogo: {
            url: "/nonprofits",
            src: "https://dapulse-res.cloudinary.com/image/upload/mondayhomepage/mini-site/ngo/monday_nonprofit_logo_unify.png",
            alt: "monday.com for non-profit"
        }
    }
};
export { MINI_SITE_CONFIGS };
